import { DataSource, Label, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBrokerRatingDetail extends Layout {
    labelAdded: Label;
    labelBrokerRatingScoreDetails3: Label;
    labelBrokerRatingScoreDetails4: Label;
    labelBrokerRatingScoreDetails: Label;
    labelDividend: Label;
    labelDivisor: Label;
    labelLeftParen: Label;
    labelRightParen: Label;
    labelSubtracted: Label;
    labelWeight: Label;
    panelFormula: Panel;
    sourceCarrierScorecardDetail: DataSource;
    tabScoringDetails: Tab;
    tabsetScoringDetails: Tabset;
    textboxEndOfPeriod: Textbox;
    textboxMinimumRecords: Textbox;
    textboxPrompt: Textbox;
    textboxStartOfPeriod: Textbox;
    textboxWeight: Textbox;
}
